import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ParametroAccionService } from 'src/app/Services/parametro-accion.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-apro-sol',
  templateUrl: './modal-apro-sol.component.html',
  styleUrls: ['./modal-apro-sol.component.css']
})
export class ModalAproSolComponent implements OnInit {

  params: any;
  private apruebasol:string = environment.apruebasol;

  constructor(private http: HttpClient, private router: Router, private fb: FormBuilder, private modalService: NgbModal, public parametroAccionService : ParametroAccionService, private toastr: ToastrService) {
    this.params = this.parametroAccionService.obtenerDatos()[0];
    //console.log(this.parametroAccionService.obtenerDatos());
  }

  ngOnInit(): void {
  }

  onSubmit() {
    this.http.post<any>(this.apruebasol, { 
      rut_empresa: this.params.RUT_EMPRESA,
      rut_representante_legal: this.params.RUT_REPRESENTANTE,
      nro_solicitud: this.params.SEQ_NRO_SOLICITUD_CDG
    }, { observe: 'response' }).subscribe((response: HttpResponse<any>) => {
      const status = response.status;
      const data = response.body;
      if (status===200) { 
        if (data.totalRecords>0) {
          this.toastr.success("Solicitud "+this.params.SEQ_NRO_SOLICITUD_CDG+" aprobada correctamente.");
          this.modalService.dismissAll();
        }else{
          this.toastr.error("Solicitud "+this.params.SEQ_NRO_SOLICITUD_CDG+" con error: "+data.Resultado.error);
          this.modalService.dismissAll();
        }
      }else{
        this.toastr.error("Solicitud "+this.params.SEQ_NRO_SOLICITUD_CDG+" con error: "+data.Resultado.error);
        this.modalService.dismissAll();
      }
    }, err => {
      console.log("error capturado");
      console.log(err);
      this.modalService.dismissAll();
    });
  }

  onCloseModalA() {
    this.modalService.dismissAll();
  }
}
